import axios from "axios";
import Cookies from "universal-cookie";

const apiURL = process.env.NODE_ENV === "development" ? "http://localhost:3001" : process.env.REACT_APP_BACKEND_API_URL;

const cookies = new Cookies();
const token = cookies.get("TOKEN");
axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

export const getMetalsService = async () => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/metals`);
  return res;
};

export const getMaterialsService = async (office: string, pageNumber: string, filters: any) => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(
    `${apiURL}/metalstrading/api/shipmentsmaterials?page=${pageNumber}&metals=${filters.metals}&startDate=${filters.startDate}&endDate=${filters.endDate}`
  );
  return res;
};

export const getSuppliersService = async () => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/suppliers`);
  return res;
};

export const getPurchaseService = async (office: string, purchaseID: string) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/purchases/${purchaseID}?office=${office}`);
  return res;
};
